const state = {
  processing: false,
};

export default state;
